import React from 'react';

import {AaSequenceAlignmentRow} from 'constants/AlignmentConstants';
import AaSequenceAlignmentStats from 'molbio/aa-sequences/alignments/AaSequenceAlignmentStats';
import {shouldShowNumbering} from 'molbio/antibody-engineering/visibilityHelpers';
import AaSequenceAlignmentRowsView from 'molbio/maps/alignment/AaSequenceAlignmentRowsView';
import AaSequenceAlignmentRowView from 'molbio/maps/alignment/AaSequenceAlignmentRowView';
import PolymerAlignmentTabView from 'molbio/maps/alignment/PolymerAlignmentTabView';
import AlignmentSummaryMapView from 'molbio/maps/alignment/summary/AlignmentSummaryMapView';
import {MIN_WIDTH_FOR_INDEX} from 'molbio/maps/linear/AntibodyNumbering';
import Type from 'molbio/maps/Type';
import AaSequenceAlignmentTabState from 'molbio/tabstates/AaSequenceAlignmentTabState';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

export default class AaSequenceAlignmentTabView extends PolymerAlignmentTabView<
  AaSequenceAlignmentRow,
  AaSequenceAlignmentTabState
> {
  addPolymersForSearch(): void {
    // TODO
  }

  removePolymersForSearch(): void {
    // TODO
  }

  getType(): Type {
    return this.model.getType();
  }

  setType(typeObj: Type): void {
    this.model.setType(typeObj);
  }

  getPolymerLength(): number {
    return this.model.getPolymerLength();
  }

  override renderStatsView(): JSX.Element | null {
    if (this.shouldCollapseMiniMap(this.model)) {
      return null;
    }

    return (
      <AaSequenceAlignmentStats
        alignment={this.model.get('alignment')!}
        selectionStart={this.model.get('selection').start()}
        selectionEnd={this.model.get('selection').end()}
      />
    );
  }

  makeSummaryMapView(): AlignmentSummaryMapView<AaSequenceAlignmentRow> {
    return new AlignmentSummaryMapView({
      model: null,
      tabstate: this.model,
      topY: ['summaryIdentityGraph', 'line'],
      middleY: ['line'],
      bottomY: [],
      padding: 172, // Keep in sync with @handle-width + 2
      isCollapsed: this.shouldCollapseMiniMap(this.model),
    });
  }

  makeRowsView(): AaSequenceAlignmentRowsView {
    return new AaSequenceAlignmentRowsView({model: this.model});
  }

  makeTopAlignmentRowView(): AaSequenceAlignmentRowView {
    return new AaSequenceAlignmentRowView({
      model: this.model,
      tabstate: this.model,
      row: this.model.get('alignment')!.rows[0],
      alignmentType: this.model.get('alignment')!.alignmentType,
      visibilityOptions: this.model.get('localVisibilityOptionsList')![0],
    });
  }

  override registerListeners(): void {
    super.registerListeners();
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'change:alignment', this.update);
  }

  override getDefaultSpan(): number {
    if (shouldShowNumbering(this.model.get('visibilityOptions'))) {
      return Math.floor(this.mapWidth() / (MIN_WIDTH_FOR_INDEX + 1));
    }

    return super.getDefaultSpan();
  }

  getDataTestAttrs(): DataTestAttrs {
    return {component: 'AaSequenceAlignmentTab', element: 'root'};
  }
}
